import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef, useState } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { DEFAULTADMINPAGE, DEFAULTUSERPAGE, NOTSCANPAGE, PAGECODE, SIDEBARDATA, USERTYPES } from "components/Common/Constant"
import { keyBy } from "lodash"

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  const [adminSession, setAdminSession] = useState([])
  const [userSession, setUserSession] = useState([])

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  useEffect(() => {
    if (sessionStorage.getItem('pages')) {
      const adSess = sessionStorage.getItem('pages').split(';')
        .map(Number)
        .filter(p => !NOTSCANPAGE.includes(p))

      // const defaultPg = user.userType === USERTYPES.Standard
      //   ? DEFAULTUSERPAGE
      //   : DEFAULTADMINPAGE

      // const usSess = sessionStorage.getItem('pages').split(';')
      //   .map(Number)
      //   .filter(p => !defaultPg.includes(p))

      setAdminSession(adSess)
      setUserSession(adSess)
    }
  }, [sessionStorage.getItem('pages')]);

  const user = useSelector((state) => state?.users.users)

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  const getRouteDetails = (page) => {
    //console.log(page, 'pagepagepagepagepage.Admin');
    return SIDEBARDATA.find(obj => obj.pageCode === page)
  }
  console.log(USERTYPES.Admin, 'USERTYPES.Admin');

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Main")} </li>

            {Object.keys(user).length !== 0 && user.userType !== USERTYPES.Admin ? (
              [
                ...NOTSCANPAGE.filter(pg => user.permissions.read.includes(pg)),
                ...userSession
              ].map((page, key) => (
                Object.values(PAGECODE).includes(page) && (
                  < li key={key} >
                    <Link to={getRouteDetails(page)?.route} className=" waves-effect">
                      {getRouteDetails(page).icon}
                      <span>{props.t(getRouteDetails(page).name)}</span>
                    </Link>
                  </li>
                )
              ))
            ) : Object.keys(user).length !== 0 && user.userType === USERTYPES.Admin ? (
              [...DEFAULTADMINPAGE, ...adminSession].map((page, key) => (
                Object.values(PAGECODE).includes(Number(page)) && (
                  <li key={key}>
                    {Number(page) === 20 ? (
                      <a
                        href={getRouteDetails(Number(page)).route}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="waves-effect"
                      >
                        {getRouteDetails(Number(page)).icon}
                        <span>{props.t(getRouteDetails(Number(page)).name)}</span>
                      </a>
                    ) : (
                      <Link
                        to={getRouteDetails(Number(page)).route}
                        className="waves-effect"
                      >
                        {getRouteDetails(Number(page)).icon}
                        <span>{props.t(getRouteDetails(Number(page)).name)}</span>
                      </Link>
                    )}

                    
                  </li>
                )
              ))

            ) : (
              <li>
                <Link to="/addsiteurl" className=" waves-effect">
                  <i className="mdi mdi-account"></i>
                  <span>{props.t("User Management")}</span>
                </Link>
              </li>
            )}

            {/* {Object.keys(user).length !== 0 && user.userType == 'superadmin' &&(

            <li>
              <Link to="/editOrganaization" className=" waves-effect">
                <i className="mdi mdi-account"></i>
                <span>Organization</span>
              </Link>
            </li>
)} */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment >
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
